<template>
  <div>
    <div class="row d-flex plano-top m-2" v-if="step > 1">
      <div class="col">
        <h5>
          <span class="mr-1">
            Plano
          </span>
          <span>
            R$ {{ formatPrice(valor) }}
            /{{ formatPeriodicidade(periodicidade) }}
          </span>

        </h5>
      </div>
    </div>

    <div class="row m-3 d-flex justify-content-between" :class="step > 1 ? 'mt-1' : 'mt-3'">
      <div class="col text-center">
        <small>Benefícios</small>
      </div>
      <div class="col  text-center">
        <small>Dados</small>
      </div>
      <div class="col text-center">
        <small>Pagamento</small>
      </div>
      <div class="col text-center">
        <small>Sucesso</small>
      </div>
    </div>

    <div class="steps row m-3 d-flex justify-content-between">

      <div class="col step icon" :class="{ 'ativo': step >= 1 }">
        <i class="fa-solid fa-1"></i>
      </div>
      <div class="col">
        <i class="fa-solid fa-arrow-right"></i>
      </div>
      <div class="col step icon" :class="{ 'ativo': step >= 2 }">
        <i class="fa-solid fa-2"></i>
      </div>
      <div class="col">
        <i class="fa-solid fa-arrow-right"></i>
      </div>
      <div class="col step icon" :class="{ 'ativo': step >= 3 }">
        <i class="fa-solid fa-3"></i>
      </div>
      <div class="col">
        <i class="fa-solid fa-arrow-right"></i>
      </div>
      <div class="col step icon" :class="{ 'ativo': step >= 4 }">
        <i class="fa-solid fa-4"></i>
      </div>
    </div>
    <hr class="ml-2" />
  </div>
</template>

<script>

import { SimuladorService } from "../../service/assinatura/SimuladorService";

const simuladorService = new SimuladorService();
export default {
  name: "SimuladorStep",
  props: ["step", "valor", "periodicidade"],
  components: {},
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {

    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatPeriodicidade(periodicidade) {
      return simuladorService.formatPeriodicidade(periodicidade);
    }
  },
};
</script>

<style scoped>
.steps {
  font-size: 165%;
}

.steps .step {
  background: silver;
  shape-outside: circle();
  clip-path: circle();
}

.steps .ativo {
  background: var(--cor-principal);
}

.steps .icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 45%;
  transition: 0.5s;
  overflow: hidden;
  color: white;
}

.plano-top {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 45px;
  line-height: 75px;
  margin-top: 10px;
  /* identical to box height */
  color: #625F5F;
}
</style>
